import { buildExpressBulkQuery } from './builders';
import store from '../../store';

/**
 * Designed to be used in place of batchQuery as a direct plug and play.
 *
 * @param {function} queryFn
 * @param {object} params
 * @returns {query} query to be POSTed
 *
 * Note: bulkQuery is Express-only (uses POST /body-query/ endpoint).
 * If the caller provides a queryBuilder that is NOT buildExpressBulkQuery
 * (i.e. LoopBack mode), we still use buildExpressBulkQuery because the
 * LoopBack API does not have a /body-query/ endpoint. Callers that need
 * LoopBack compatibility should use batchQuery (GET-based) instead.
 * The queryBuilder param is preserved for API compatibility but is
 * overridden here — this is intentional, not a bug.
 */
const bulkQuery = (queryFn, params) => {
    const { region } = store.getState().persisted.auth.user.data;
    const newParams = params;
    // bulkQuery is Express-only: the /body-query/ POST endpoint exists
    // only in Express. Override the queryBuilder regardless of what the
    // caller passes. Callers needing LoopBack should use batchQuery.
    newParams.queryBuilder = buildExpressBulkQuery;
    const query = queryFn(newParams);
    return query;
};

export default bulkQuery;
